import { makeVar, ReactiveVar, useReactiveVar } from '@apollo/client';
import { colors } from 'src/theme';

// ============ INTERFACE ============

export interface MessageState {
  visible: boolean;
  message: string;
  duration: number;
  backgroundColor?: string;
  color?: string;
  isExiting?: boolean;
  fixed?: boolean;
}

export type MessageType = 'success' | 'error' | 'info';

interface ShowMessageParams {
  type: MessageType;
  message: string;
  duration?: number;
  fixed?: boolean;
}

// ============ REACTIVE VARIABLES ============

const initialState: MessageState = {
  visible: false,
  message: '',
  duration: 10000,
  color: undefined,
  backgroundColor: undefined,
  isExiting: false,
  fixed: false
};

export const messageVar: ReactiveVar<MessageState> = makeVar<MessageState>(initialState);

// ============ ACTIONS ============

export const showMessage = ({ type, message, duration = 10000, fixed = false }: ShowMessageParams): void => {
  let backgroundColor = colors.success2;
  let color = colors.text1;

  switch (type) {
    case 'success':
      backgroundColor = colors.success2;
      color = colors.black;
      break;
    case 'error':
      backgroundColor = colors.error2;
      color = colors.white;
      break;
    case 'info':
      backgroundColor = colors.primary5;
      break;
  }

  messageVar({
    visible: true,
    message,
    duration,
    color,
    backgroundColor,
    fixed
  });

  // Automatski sakrij poruku nakon određenog vremena
  setTimeout(() => {
    hideMessage();
  }, duration);
};

export const hideMessage = (): void => {
  messageVar({
    ...messageVar(),
    isExiting: true
  });

  setTimeout(() => {
    messageVar({
      ...initialState
    });
  }, 500);
};

export const useMessage = (): MessageState => {
  const messageState = useReactiveVar(messageVar);
  return messageState;
};